import { DropdownButton, FormControl, InputGroup, MenuItem, NavItem } from 'react-bootstrap';
import { XmListType } from '@nkr/store/xm-tracking';
import { NavWrapper } from './styles';
import { IXmTrackingCounts } from '@nkr/models/xm-tracking/counts';
import { FilterCenterBy } from './filter-center-by';
import styled from 'styled-components';

const Wrapper = styled.div`
    margin-bottom: 10px;

    #filter-center-by {
        border-radius: 0px;
        border-right: 0 none;
    }
`;

interface IProps {
    listType: XmListType,
    counts: IXmTrackingCounts,
    filterCenterBy: FilterCenterBy,
    filterCenterId: number,
    centerList: { id: number, alias: string, isRecipientCenter: boolean }[],
    onTabChange: (listType: XmListType) => void,
    onFilterCenterByChange: (filterCenterBy: FilterCenterBy) => void,
    onCenterChange: (id: number) => void
}

const AdminTabs: React.FunctionComponent<IProps> = (props) => {
    const handleFilterByChange = (filterCenterBy: any) => {
        props.onFilterCenterByChange(filterCenterBy);
    }

    const handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        props.onCenterChange(parseInt(e.currentTarget.value));
    };

    let psCounts = props.counts != null ? props.counts.kitsRequested : 0;
    let pdcCounts = props.counts != null ? props.counts.pendingDonorCenter : 0;
    let prcCounts = props.counts != null ? props.counts.pendingRecipientCenter : 0;
    let completedCounts = props.counts != null ? props.counts.completed : 0;
    let cancelledCounts = props.counts != null ? props.counts.cancelled : 0;

    let filterCenterByTitle = props.filterCenterBy == FilterCenterBy.RecipientCenter ? 'Recipient Center' : 'Donor Center';

    let centerList = props.centerList.filter(x => {
        return props.filterCenterBy == FilterCenterBy.RecipientCenter ? x.isRecipientCenter : !x.isRecipientCenter;
    });

    return (
        <div style={{ marginBottom: 10, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <div style={{ marginBottom: 5 }}>
                <NavWrapper bsStyle='tabs' bsSize='sm' activeKey={props.listType} onSelect={(tab: any) => props.onTabChange(tab)}>
                    <NavItem eventKey={XmListType.AdminPendingShipping}>Pending Shipping ({psCounts})</NavItem>
                    <NavItem eventKey={XmListType.AdminShippedPendingDCenter}>Shipped Pending Donor Center ({pdcCounts})</NavItem>
                    <NavItem eventKey={XmListType.AdminShippedPendingRCenter}>Shipped Pending Recipient Center ({prcCounts})</NavItem>
                    <NavItem eventKey={XmListType.AdminCompleted}>Completed ({completedCounts})</NavItem>
                    <NavItem eventKey={XmListType.AdminCancelled}>Cancelled ({cancelledCounts})</NavItem>
                </NavWrapper>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ marginRight: 5 }}>Filter&nbsp;</div>

                    <DropdownButton title={filterCenterByTitle} id='filter-center-by' key={props.filterCenterBy} onSelect={handleFilterByChange}>
                        <MenuItem eventKey={FilterCenterBy.RecipientCenter}>Recipient Center</MenuItem>
                        <MenuItem eventKey={FilterCenterBy.DonorCenter}>Donor Center</MenuItem>
                    </DropdownButton>

                    <div style={{ marginLeft: 5, marginRight: 5 }}>by</div>

                    <FormControl
                        componentClass='select'
                        value={props.filterCenterId}
                        onChange={handleCenterChange}
                    >
                        <option value={0}>- All Centers -</option>
                        {centerList.map(center =>
                            <option key={'ctr-' + center.id} value={center.id}>{center.alias}</option>
                        )}
                    </FormControl>
                </div>
            </div>
        </div>
    );
}

export default AdminTabs;